"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var context_1 = require("./context");
var SIZE_MAP = {
    small: 16,
    default: 16,
    large: 20,
};
var ButtonIcon = function (_a) {
    var Icon = _a.icon;
    var size = context_1.useButtonContext().size;
    return (react_1.jsx(Icon, { size: SIZE_MAP[size] }));
};
exports.default = ButtonIcon;
